export const POSchemas: Record<string, any> = {
  extraction:
  {
    "fields": {
        "inv_id": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "file_name": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "start_time": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Vendor_Name": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true,
            "visible": true
        },
        "Invoice_Number": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Invoice_Date": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Po_Number": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Po_Date": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Vendor_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Vendor_PAN": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Vendor_Address": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Vendor_Postal_Code": {
            "type": "string",
            "isEditable": true
        },
        "Buyer_Name": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Buyer_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Buyer_PAN": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Buyer_Address": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "IRN_Number": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Eway_Bill_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Total_Tax": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Freight": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Rounding_Off": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Grand_Total": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Currency": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true,
            "visible": true
        },
        "MSME_Number": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Product_Name": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Status": {
            "type": "string",
            "isEditable": false,
            "visible": false
        }
    },
    "tables": [
        {
            "Invoice_line_Items": {
                "columns": [
                    {
                        "name": "line_item_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "line_item_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "Item_Description",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Material_Code",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Po_Number",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Quantity",
                        "type": "string",
                        "min": 1,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "HSN_SAC_Code",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Rate_Per_Unit",
                        "type": "string",
                        "min": 1,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "UOM",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Line_Amount",
                        "type": "string",
                        "min": 1,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Line_OCR_Status",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    }
                ]
            }
        }
    ]
}
, validation:
{
    "fields": {
        "inv_id": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "po_id": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "file_name": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "inv_date_time": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Vendor_Name": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "PO_Vendor_Name": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_Name_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Vender_Code": {
            "type": "string",
            "isEditable": false
        },
        "Invoice_Number": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "GRN_Invoice_Number": {
            "type": "string",
            "isEditable": false
        },
        "Invoice_Date": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Po_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Po_Date": {
            "type": "string",
            "isEditable": true
        },
        "Vendor_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "PO_Vendor_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_GSTIN_OR_Tax_Identification_Number_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_PAN": {
            "type": "string",
            "isEditable": true
        },
        "PO_Vendor_PAN": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_PAN_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_Address": {
            "type": "string",
            "isEditable": false
        },
        "PO_Vendor_Address": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_Address_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_Name": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "PO_Buyer_Name": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_Name_Validation": {
            "type": "string",
            "isEditable": false
        },
        "PO_Company_Code": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "PO_Buyer_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_GSTIN_OR_Tax_Identification_Number_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_PAN": {
            "type": "string",
            "isEditable": true
        },
        "PO_Buyer_PAN": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_PAN_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_Address": {
            "type": "string",
            "isEditable": false
        },
        "PO_Buyer_Address": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_Address_Validation": {
            "type": "string",
            "isEditable": false
        },
        "IRN_Number": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Eway_Bill_Number": {
            "type": "string",
            "isEditable": true
        },
        "Total_Tax": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Freight": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Rounding_Off": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Grand_Total": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Currency": {
            "type": "string",
            "isEditable": true
        },
        "PO_Currency": {
            "type": "string",
            "isEditable": false
        },
        "Currency_Validation": {
            "type": "string",
            "isEditable": false
        },
        "MSME_Number": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Product_Name": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Status": {
            "type": "string",
            "isEditable": false,
            "visible": false
        }
    },
    "tables": [
        {
            "Invoice_line_Items": {
                "columns": [
                    {
                        "name": "line_item_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "line_item_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "Inv_Material_Code",
                        "type": "string",
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Inv_Description",
                        "type": "string",
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Inv_Quantity",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Inv_HSN_SAC_Code",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Inv_Rate_Per_Unit",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "UOM",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Line_Amount",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Status",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    }
                ]
            }
        },
        {
            "PO_Line_Items": {
                "columns": [
                    {
                        "name": "po_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "po_line_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "line_item_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "po_start_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "PO_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Item",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Name",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Material_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Description",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Address",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_GSTIN_OR_TIN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_PAN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Name",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Company_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Address",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Pin_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Country",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_GSTIN_OR_TIN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_PAN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Quantity",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Rate_Per_Unit",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PO_UOM",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Per",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "HSN_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Currency",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Tax_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Tollerance_Limit",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Year",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_UOM",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Invoice_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Invoice_Date",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "BE_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Quantity",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Total_Base_Amount",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Taxable_Amount",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Plant",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Business_Area",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GL_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Total_GRN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_Condition",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCL_Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_IRL",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GR",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "IR_L",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "IR_L_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_Condition",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_IRL",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PURCHASE_ORG",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PURCHASE_GROUP",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    }
                ]
            }
        }
    ]
}
, po:
{
    "fields": {
        "inv_id": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "file_name": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "start_time": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Vendor_Name": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true,
            "visible": true
        },
        "Invoice_Number": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "GRN_Invoice_Number": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Invoice_Date": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Po_Number": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Po_Date": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Vendor_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Vendor_PAN": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Vendor_Address": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Vendor_Postal_Code": {
            "type": "string",
            "isEditable": true
        },
        "Buyer_Name": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Buyer_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Buyer_PAN": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Buyer_Address": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "IRN_Number": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Eway_Bill_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Total_Tax": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Freight": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Rounding_Off": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Grand_Total": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Currency": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true,
            "visible": true
        },
        "MSME_Number": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Product_Name": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Status": {
            "type": "string",
            "isEditable": false,
            "visible": false
        }
    },
    "tables": [
        {
            "Invoice_line_Items": {
                "columns": [
                    {
                        "name": "line_item_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "line_item_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "Item_Description",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Material_Code",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Po_Number",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Quantity",
                        "type": "string",
                        "min": 1,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "HSN_SAC_Code",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Rate_Per_Unit",
                        "type": "string",
                        "min": 1,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "UOM",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Line_Amount",
                        "type": "string",
                        "min": 1,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Line_OCR_Status",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    }
                ]
            }
        },
        {
            "PO_Line_Items": {
                "columns": [
                    {
                        "name": "po_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "po_line_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "line_item_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "po_start_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "PO_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Item",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Name",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Material_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Description",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Address",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_GSTIN_OR_TIN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_PAN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Name",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Company_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Address",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Pin_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Country",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_GSTIN_OR_TIN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_PAN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Quantity",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Rate_Per_Unit",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PO_UOM",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Per",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "HSN_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Currency",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Tax_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Tollerance_Limit",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Year",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_UOM",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Invoice_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Invoice_Date",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "BE_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Quantity",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Total_Base_Amount",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Taxable_Amount",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Plant",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Business_Area",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GL_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Total_GRN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_Condition",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCL_Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_IRL",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GR",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "IR_L",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "IR_L_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_Condition",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_IRL",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PURCHASE_ORG",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PURCHASE_GROUP",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    }
                ]
            }
        }
    ]
}
,
 miro:
 {
    "fields": {
        "inv_id": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "po_id": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "file_name": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "inv_date_time": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Vendor_Name": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "PO_Vendor_Name": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_Name_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Vender_Code": {
            "type": "string",
            "isEditable": false
        },
        "Invoice_Number": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "GRN_Invoice_Number": {
            "type": "string",
            "isEditable": false
        },
        "Invoice_Date": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Po_Number": {
            "type": "string",
            "min": 1,
            "required": true,
            "isEditable": true
        },
        "Po_Date": {
            "type": "string",
            "isEditable": true
        },
        "Vendor_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "PO_Vendor_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_GSTIN_OR_Tax_Identification_Number_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_PAN": {
            "type": "string",
            "isEditable": true
        },
        "PO_Vendor_PAN": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_PAN_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_Address": {
            "type": "string",
            "isEditable": false
        },
        "PO_Vendor_Address": {
            "type": "string",
            "isEditable": false
        },
        "Vendor_Address_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_Name": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "PO_Buyer_Name": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_Name_Validation": {
            "type": "string",
            "isEditable": false
        },
        "PO_Company_Code": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "PO_Buyer_GSTIN_OR_Tax_Identification_Number": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_GSTIN_OR_Tax_Identification_Number_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_PAN": {
            "type": "string",
            "isEditable": true
        },
        "PO_Buyer_PAN": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_PAN_Validation": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_Address": {
            "type": "string",
            "isEditable": false
        },
        "PO_Buyer_Address": {
            "type": "string",
            "isEditable": false
        },
        "Buyer_Address_Validation": {
            "type": "string",
            "isEditable": false
        },
        "IRN_Number": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Eway_Bill_Number": {
            "type": "string",
            "isEditable": true
        },
        "Total_Tax": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Freight": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Rounding_Off": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Grand_Total": {
            "type": "string",
            "min": 2,
            "required": true,
            "isEditable": true
        },
        "Currency": {
            "type": "string",
            "isEditable": true
        },
        "PO_Currency": {
            "type": "string",
            "isEditable": false
        },
        "Currency_Validation": {
            "type": "string",
            "isEditable": false
        },
        "MSME_Number": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Product_Name": {
            "type": "string",
            "isEditable": false,
            "visible": false
        },
        "Status": {
            "type": "string",
            "isEditable": false,
            "visible": false
        }
    },
    "tables": [
        {
            "Invoice_line_Items": {
                "columns": [
                    {
                        "name": "line_item_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "line_item_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "Inv_Material_Code",
                        "type": "string",
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Inv_Description",
                        "type": "string",
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Inv_Quantity",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Inv_HSN_SAC_Code",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Inv_Rate_Per_Unit",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "UOM",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Line_Amount",
                        "type": "string",
                        "min": 2,
                        "required": true,
                        "isEditable": true,
                        "visible": true
                    },
                    {
                        "name": "Status",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    }
                ]
            }
        },
        {
            "PO_Line_Items": {
                "columns": [
                    {
                        "name": "po_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "po_line_id",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "line_item_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "po_start_time",
                        "type": "string",
                        "isEditable": false,
                        "visible": false
                    },
                    {
                        "name": "PO_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Item",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Name",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Material_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Description",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_Address",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_GSTIN_OR_TIN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Vendor_PAN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Name",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Company_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Address",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Pin_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_Country",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_GSTIN_OR_TIN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Buyer_PAN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Quantity",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Rate_Per_Unit",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PO_UOM",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Per",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "HSN_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Currency",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Tax_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Tollerance_Limit",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Year",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_UOM",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Invoice_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Invoice_Date",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "BE_Number",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GRN_Quantity",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Total_Base_Amount",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Taxable_Amount",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Plant",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Business_Area",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GL_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "Total_GRN",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_Condition",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCL_Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_IRL",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLR_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "GR",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "IR_L",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "IR_L_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_Condition",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_Vendor_Code",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_IRL",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "ZCLI_INV",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PURCHASE_ORG",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    },
                    {
                        "name": "PURCHASE_GROUP",
                        "type": "string",
                        "isEditable": false,
                        "visible": true
                    }
                ]
            }
        }
    ]
}
};